export default __webpack_public_path__ + "static/media/function_light.8e811828.svg";